import { drawCombinedContent, drawContainer, drawNotificationContent } from './drawers';
import { calculateLayout, computeNotifications } from './helpers';
import { getNotificationConfig } from './notification-configs';
import { NotificationTypeId } from './types';

/**
 * Главная функция отрисовки canvas-нотификаций.
 *
 * Отрисовывает:
 * - Primary row: отдельные нотификации (mute, hand) с gap между ними
 * - Secondary row: объединённая нотификация (waiting room, summarization, recording)
 *
 * @param ctx - контекст canvas для отрисовки
 * @param activeTypes - массив активных типов нотификаций
 */
export function drawCanvasNotifications(
    ctx: CanvasRenderingContext2D,
    activeTypes: NotificationTypeId[],
    shouldDrawAloneScreen: boolean
): void {
    if (activeTypes.length === 0) {
        return;
    }

    // 1. Группируем по строкам (primary/secondary)
    const notifications = computeNotifications(activeTypes, getNotificationConfig);

    // 2. Рассчитываем лейаут (с кэшированием)
    const canvasWidth = ctx.canvas.width;
    const canvasHeight = ctx.canvas.height;
    const layout = calculateLayout(ctx, canvasWidth, canvasHeight, notifications, shouldDrawAloneScreen);

    // 3. Отрисовываем primary row (каждую нотификацию отдельно)
    for (let i = 0; i < notifications.primary.length; i++) {
        const area = layout.primaryAreas[i];
        const config = notifications.primary[i];

        drawContainer(ctx, area);
        drawNotificationContent(ctx, area, config);
    }

    // 4. Отрисовываем secondary row (объединённую нотификацию)
    if (layout.secondaryArea && notifications.secondary.length > 0) {
        drawContainer(ctx, layout.secondaryArea);
        drawCombinedContent(ctx, layout.secondaryArea, notifications.secondary);
    }
}
